import React from 'react'
import AboutUsForm from '../components/Aboutus'

const AboutUs = () => {
  return (
    <div className='pt-[50px] pb-[50px]'>
        <AboutUsForm/>
    </div>
  )
}

export default AboutUs